import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-our-services',
  imports: [],
  templateUrl: './our-services.component.html',
  styleUrl: './our-services.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OurServicesComponent { }
